import { Component, OnInit } from '@angular/core';

import { AuthService } from '../../../core/auth.service';
import { Router } from '@angular/router';
import { confirm, alert } from 'devextreme/ui/dialog';
import { PasswordComponent } from '../password/password.component';
import { BsModalService } from 'ngx-bootstrap/modal';
import { AppInformationService } from '../../../core/app-information.service';
import { UtilityService } from '../../../core/core.module';
import { first } from 'rxjs';
import { DevExtremeModule } from 'devextreme-angular';

@Component({
    selector: 'app-login',
    templateUrl: './login.component.html',
    styleUrls: ['./login.component.css'],
    imports: [DevExtremeModule],
    standalone: true,
})
export class LoginComponent implements OnInit {
    model = { userName: '', password: '' };
    church: string;

    constructor(private auth: AuthService, private router: Router, private appInfo: AppInformationService, private modalService: BsModalService, private utility: UtilityService) {}

    ngOnInit() {
        this.auth.logout();
        switch (this.appInfo.settings.church) {
            case 'neland':
                this.church = 'Neland Church';
                break;
            case 'graafschap':
                this.church = 'Graafschap CRC';
                break;
        }
    }

    async login() {
        await this.appInfo.pleaseWaitShow();
        this.auth
            .login(this.model.userName, this.model.password)
            .pipe(first())
            .subscribe({
                next: async () => {
                    try {
                        if (this.auth.currentUser) {
                            await this.utility.logUser();
                            this.router.navigate(['/']);
                            this.appInfo.pleaseWaitHide();
                            return;
                        }
                        this.appInfo.pleaseWaitHide();
                        alert('Error logging into server', 'Login Error');
                    } catch (exception) {
                        const ex: any = exception;
                        this.appInfo.pleaseWaitHide();
                        console.log(ex);
                        await alert(exception?.message || 'Error logging into server', 'Login Error');
                    } finally {
                        this.appInfo.pleaseWaitHide();
                    }
                },
                error: async (exception) => {
                    await alert(exception?.message || 'Error logging into server', 'Login Error');
                    this.appInfo.pleaseWaitHide();
                },
            });
    }
}
